import { TextField } from "@mui/material"
import { useState } from "react";

const DecimalValueColumnField = ({ isPurchase, params, isUnitPrice, gridApiRef, t, updatedRow, setError }) => {
    const [isFocused, setIsFocused] = useState(false);
    const [inputValue, setInputValue] = useState('');

    const formatNumber = (num: number) => {
        return new Intl.NumberFormat('en-US', {
            style: 'decimal',
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            useGrouping: true,
        }).format(num).replace(/,/g, ' ').replace('.', ',');
    };

    const handleDecimalKeyDown = (event: React.KeyboardEvent) => {
        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
        const allowedKeysWithCTRL = ['c', 'x', 'v'];
        const isNumericOrComma = /^[0-9,.]$/;
        const key = event.key;

        if (!isNumericOrComma.test(key) && !allowedKeys.includes(key) && !(event.ctrlKey && allowedKeysWithCTRL.includes(key.toLowerCase()))) {
            event.stopPropagation();
            event.preventDefault();
        }

        if ((key === ',' || key === '.') && (inputValue.includes(',') || inputValue.includes('.'))) {
            event.stopPropagation();
            event.preventDefault();
        }
    };

    const handlePaste = (event: React.ClipboardEvent) => {
        const pasteData = event.clipboardData.getData('Text');
        if (!/^[0-9,.]*$/.test(pasteData)) {
            event.stopPropagation();
            event.preventDefault();
        }
    };

    const handleValueChange = (newValue, row) => {
        if (isUnitPrice)
            setInputValue(newValue);
        else if (isPurchase || (isNaN(parseFloat(newValue.replace(',', '.'))) ? 0 : customRound(parseFloat(newValue.replace(',', '.')))) <= row.totalUnitsCount)
            setInputValue(newValue);
        else {
            setError(t('warehouses.quantityGreaterThanAvailable'));
            setInputValue((row.totalUnitsCount ?? 0).toString().replace('.', ','));
        }
        gridApiRef.current.updateRows([row]);
    };

    const handleBlur = (row, newValue) => {
        setIsFocused(false);
        if (isUnitPrice) {
            const formattedRow = {
                ...row,
                unitsPrice: newValue
            };
            updatedRow(formattedRow);
        }
        else {
            const formattedRow = {
                ...row,
                unitsCount: newValue
            };
            updatedRow(formattedRow);
        }
    };

    const customRound = (num: number) => {
        const factor = Math.pow(10, 2);
        return (num * factor % 1 >= 0.5 ? Math.ceil(num * factor) : Math.floor(num * factor)) / factor;
    };

    return (
        <TextField
            autoComplete="off"
            type="text"
            value={isFocused ? inputValue : formatNumber(params.value ?? 0)}
            onChange={(event) => handleValueChange(event.target.value, params.row)}
            onBlur={(e) => handleBlur(params.row, isNaN(parseFloat(e.target.value.replace(',', '.'))) ? 0 : customRound(parseFloat(e.target.value.replace(',', '.'))))}
            onFocus={() => {
                setInputValue((params.value ?? '0').toString().replace('.', ','));
                setIsFocused(true);
            }}
            onKeyDown={handleDecimalKeyDown}
            onPaste={handlePaste}
            fullWidth
            sx={{
                '& .MuiOutlinedInput-root': {
                    backgroundColor: '#e8f5e9', // Light green background by default
                    '&.Mui-focused': {
                        backgroundColor: '#ffe0b2', // Orange background when focused
                    },
                    '& fieldset': {
                        borderColor: 'transparent !important',
                    },
                },
                '& .MuiInputBase-input': {
                    marginLeft: '-15px',
                    marginTop: '-11px',
                    textAlign: 'right',
                },
                marginTop: '-2px',
            }}
        />
    );
}

export default DecimalValueColumnField;